import React from "react";

import "./styles.less";

export const DocBlock = (props) => {
  const { title, subtitle = null, keyId, children } = props;
  return (
    <div className="playground-block">
      <h3 className="title" id={keyId}>
        {title}
      </h3>
      {subtitle && <div className="subtitle">{subtitle}</div>}
      {children}
    </div>
  );
};
